import uuid from "~/utils/uuid"
import errorUtils from "~/utils/errorUtils"
import printerNotifier from "~/utils/printerNotifier";
import slsApi from "~/request/slsApi";
import WarehouseApi from "~/request/warehouseApi";

const commandCallback = {}

const onMessage = (event) => {
    let response = {}
    try {
        response = JSON.parse(event.data)
    } catch (err) {
        errorUtils.uploadError('onmessage', 'JSON解析异常:' + event.data + ' / ' + JSON.stringify(err)).then(() => {
            console.log('上传异常成功！', err)
        }).catch(error => console.error('上传异常失败：', err, error))
    }
    //拿到打印结果的回调
    // 拼多多打印组件回调 cmd 为 PrintResultNotify，其余组件(菜鸟/字节/快手/小红书)为 notifyPrintResult，
    // 两者的 taskStatus / printStatus 结构一致，这里统一处理，保证拼多多出单也能上报(维护出单数量)
    if (response.cmd === 'notifyPrintResult' || response.cmd === 'PrintResultNotify') {
        console.log('拿到打印结果的回调', response)
        try {
            //文档打印结果列表
            // 菜鸟打印会回传渲染完成的状态
            // 渲染完成就不回传，只回传 失败 和 出纸完成
            if (response.taskStatus && response.taskStatus !== 'rendered') {
                const {printStatus} = response

                if (printStatus && printStatus.length) {
                    printStatus.forEach(docRes => {
                        printerNotifier.setNotifierResponse(docRes.documentID, docRes)
                        printerNotifier.notifyListeners(docRes.documentID)
                    })
                }
                response.deviceMonitorId = WarehouseApi.getDeviceMonitorId()
                slsApi.logPrinterResultList([response]).then(() => {
                    console.log('打印日志记录成功！')
                }).catch(err => {
                    console.error('打印日志记录失败', response, err)
                    errorUtils.uploadError('打印日志记录失败', JSON.stringify(response)).then(() => console.log('上传 打印日志记录失败 成功', err)).catch(error => {
                        console.error('上传 打印日志记录失败 失败', error, err)
                    })
                })
            } else {
                errorUtils.uploadError('其他打印通知记录', JSON.stringify(response))
                    .then(() => console.log('其他打印通知记录记录成功'))
                    .catch(err => {
                    console.error('其他打印通知记录记录失败', err)
                })
            }
        } catch (e) {
            errorUtils.uploadError('上传打印日志动作异常', e.message).then(() => console.log('上传打印日志动作异常成功', e)).catch(err => {
                console.error('上传打印日志动作异常失败', e, err)
            })
        }
    }
    if (commandCallback['f' + response.requestID]) {
        commandCallback['f' + response.requestID](response)
    }
}

/***
 * 构造request对象
 */
const getRequestObject = cmd => {
    let request = {}
    request.requestID = uuid.getUUID(8, 16)
    request.version = "1.0"
    request.cmd = cmd
    return request
}

const getPrinters = (socket) => {
    const request = getRequestObject('getPrinters')
    console.log('getPrinters', socket)
    return sendCommand(socket, request)
}

// 获取打印机配置(getPrinterConfig)
const getPrinterConfig = (socket, printer) => {
    const request = getRequestObject('getPrinterConfig')
    request.printer = printer
    return sendCommand(socket, request)
}

// 设置打印机配置(setPrinterConfig)
const setPrinterConfig = (socket, options) => {
    const request = getRequestObject('setPrinterConfig')
    copyProperties(request, options)
    return sendCommand(socket, request)
}

// 发送打印/预览数据协议(print)
const print = (socket, options) => {
    const request = getRequestObject('print')
    copyProperties(request, options)
    return sendCommand(socket, request)
}

// 打印通知(notifyPrintResult) ignore
const notifyPrintResult = (socket, options) => {
    const request = getRequestObject('notifyPrintResult')
    copyProperties(request, options)
    return sendCommand(socket, request)
}

// 获取任务打印任务状态(getTaskStatus)
const getTaskStatus = (socket, taskIDArray) => {
    const request = getRequestObject('getTaskStatus')
    request.taskID = taskIDArray
    return sendCommand(socket, request)
}

// 获取全局配置
const getGlobalConfig = (socket) => {
    const request = getRequestObject('getGlobalConfig')
    return sendCommand(socket, request)
}

// 设置全局配置
const setGlobalConfig = (socket, notifyOnTaskFailure) => {
    const request = getRequestObject('setGlobalConfig')
    request.notifyOnTaskFailure = notifyOnTaskFailure
    return sendCommand(socket, request)
}

// 获取客户端版本信息(getAgentInfo)
const getAgentInfo = (socket) => {
    const request = getRequestObject('getAgentInfo')
    return sendCommand(socket, request)
}

const sendCommand = (socket, request) => {
    return new Promise(resolve => {
        socket.send(JSON.stringify(request))
        commandCallback['f' + request.requestID] = (response) => {
            resolve(response)
            commandCallback['f' + request.requestID] = null
        }
    })
}

const copyProperties = (target, source) => {
    for (let key in source) {
        if (source.hasOwnProperty(key))
            target[key] = source[key]
    }
}


export default {
    onMessage,
    getPrinters,
    getPrinterConfig,
    setPrinterConfig,
    print,
    notifyPrintResult,
    getTaskStatus,
    getGlobalConfig,
    setGlobalConfig,
    getAgentInfo
}


// WEBPACK FOOTER //
// ./src/service/basePrinter.js